import { MapPin, Clock, Rocket } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

export default function Eventos({ datos, seccion }) {
  const eventos = datos.eventos || [];
  if (eventos.length === 0) return null;

  return (
    <section className="kx-seccion" aria-label={seccion.titulo}>
      <div className="kx-seccion-interior">
        <EncabezadoSeccion p="kx" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="kx-titulo-eventos" />
        <div className="kx-eventos-lista">
          {eventos.map((ev, i) => (
            <Reveal key={ev.id || i} delay={i * 0.08}>
              <article className="kx-evento" data-testid={`kx-evento-${ev.id || i}`}>
                <span className="kx-evento-icono">
                  <Rocket strokeWidth={1.8} />
                </span>
                <p className="kx-evento-etiqueta">{ev.etiqueta}</p>
                <h3 className="kx-evento-nombre">{ev.lugar}</h3>
                <p className="kx-evento-detalle">
                  <Clock strokeWidth={2} />
                  <span>{ev.horario}</span>
                </p>
                <p className="kx-evento-detalle">
                  <MapPin strokeWidth={2} />
                  <span>{ev.direccion}</span>
                </p>
                {ev.urlUbicacion && (
                  <a
                    className="kx-boton"
                    href={ev.urlUbicacion}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`kx-boton-ubicacion-${ev.id || i}`}
                  >
                    <MapPin strokeWidth={2} />
                    {ev.textoBoton || "Cómo llegar"}
                  </a>
                )}
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
